const Shortvas = require("shortvas");
const CheckerboardPaths = require("./CheckerboardPaths");
const CityWalks = require("./CityWalks");
const GridShapes = require("./GridShapes");
const Colorominoes = require("./Colorominoes");
const Common = require("./CommonHelpers");
const CrossSums = require("./CrossSums");
const CubeVolume = require("./CubeVolume");
const DotGroups = require("./DotGroups");
const DotTrace = require("./DotTrace");
const Encircle = require("./Encircle");
const EngineHelper = require("./EngineHelper");
const LessonSpecificHelpers = require("./LessonSpecificHelpers");
const RenderHelper = require("../util/RenderHelpers");
const RoundVolume = require("./RoundVolume");
const rrDraw = require("./rrDraw");
const ShapeArea = require("./ShapeArea");
const ShapeVolume = require("./ShapeVolume");
const TapeDiagram = require("./TapeDiagram");
const WaterfallPuzzle = require("./WaterfallPuzzle");
const DivisionNetworks = require("./DivisionNetworks");
const XOGrid = require("./XOGrid");
const KeepingTrack = require("./KeepingTrack");
const {V, V3} = require("./VectorDraw");

module.exports = {
	// Basic commands
	drawBatex: Common.drawBatex,
	measureBatex: Common.measureBatex,
	// Other commands
	CheckerboardPaths: CheckerboardPaths.drawCheckerBoardPaths,
	CityWalks: CityWalks.drawCityWalks,
	GridShapes: GridShapes.drawGridShapes,
	Colorominoes,
	console: Common.console,
	CrossSums,
	CubeVolume,
	D: Common.D,
	Dir: Common.D,
	DotGroups,
	DotTrace,
	drawBatexAtCenter: Common.drawBatexAtCenter,
	drawBatexInRect: Common.drawBatexInRect,
	drawArrow: Common.drawArrow,
	drawQuadArrow: Common.drawQuadArrow,
	drawToothpick: Common.drawToothpick,
	drawProtractor: Common.drawProtractor,
	drawRuler: Common.drawRuler,
	drawCurlyBrace: RenderHelper.drawCurlyBrace,
	Encircle,
	EngineHelper,
	fillAll: Common.fillAll,
	KeepingTrack: KeepingTrack.base,
	KeepingTrackPairs: KeepingTrack.pairs,
	label: Common.label,
	LH: LessonSpecificHelpers,
	rrDraw,
	RoundVolume,
	ShapeArea,
	ShapeVolume,
	Shortvas,
	TapeDiagram,
	V,
	V3,
	WaterfallPuzzle,
	DivisionNetworks,
	XOGrid,
};
